import { render, staticRenderFns } from "./ValidationFailureModal.vue?vue&type=template&id=b37ce094&"
import script from "./ValidationFailureModal.vue?vue&type=script&lang=js&"
export * from "./ValidationFailureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports